import { Bell as BellIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Bell';
import { useOnOutsideClick } from '@bnnvara/react-hooks';
import React, { useRef } from 'react';

import { useNotifications } from '../../../../hooks/notifications';
import useUI, {
  TYPE_TOGGLE_NOTIFICATIONS_DROPDOWN,
} from '../../../../hooks/useUI';
import { NotificationsDropdown } from './NotificationsDropdown';
import * as S from './styled';

const NotificationsHub = () => {
  const {
    isLoading,
    notifications,
    unreadCount,
    setNotificationsOnRead,
  } = useNotifications();
  const {
    state: { notificationsDropdownOpen },
    dispatch,
  } = useUI();
  const showNumberOfNotifications = unreadCount !== 0;
  const refDropdownContainer = useRef();

  /**
   * Put notification on read when a user click on hub and on a dropdownItem
   * Why dropdownItem? It is possible that the dropdown is open,
   * and that on that time a user receives a notification trough the websocket.
   */
  function clickHandler() {
    /**
     * Don't execute the mutation if there are 0 unread notifications,
     * to prevent unnecessary load in BFF and BE.
     * Also only execute if de dropDown is open, to assure
     * the dots (read or not read) of individual notifications is visible.
     */
    if (unreadCount > 0 && notificationsDropdownOpen) {
      setNotificationsOnRead();
    }

    dispatch({ type: TYPE_TOGGLE_NOTIFICATIONS_DROPDOWN });
  }

  useOnOutsideClick(refDropdownContainer, () => {
    if (notificationsDropdownOpen) {
      setNotificationsOnRead();

      dispatch({ type: TYPE_TOGGLE_NOTIFICATIONS_DROPDOWN });
    }
  });

  return (
    <div ref={refDropdownContainer}>
      <S.Wrapper>
        <S.IconButton
          onClick={clickHandler}
          isDropdownOpen={notificationsDropdownOpen}
        >
          <BellIcon />
          {showNumberOfNotifications && (
            <S.NumberOfNotifications>{unreadCount}</S.NumberOfNotifications>
          )}
        </S.IconButton>
        {notificationsDropdownOpen && (
          <NotificationsDropdown
            isLoading={isLoading}
            notifications={notifications}
            setNotificationsOnRead={clickHandler}
          />
        )}
      </S.Wrapper>
    </div>
  );
};

export default NotificationsHub;
